import styled from "styled-components";

export const ContentCoaches = styled.div` 
    .coaches-title {
        font-size: 24px;
        font-weight: 700;
        a {
            color: ${({ theme }) => theme.secondaryDarkOne};
            text-decoration: none;
        }
        .MuiSvgIcon-root {
            font-size: 16px;
            margin-left: 15px;
        }
    }
`;